<div class="error-dialog">
    <button type="button" class="close-button" aria-label="Dialog schließen" (click)="close()">
        ×
    </button>

    <h2>{{ data.title }}</h2>

    <p>{{ data.message }}</p>

    @if (data.chips?.length) {
    <div class="error-chip-list">
        @for (chip of data.chips; track chip) {
        <span class="error-chip">
            {{ chip }}
        </span>
        }
    </div>
    }
    <footer class="dialog-actions">
        <button type="button" class="ok-button" (click)="close()">
            OK
        </button>
    </footer>
</div>